module.exports = __webpack_public_path__ + "img/JAOC_POP_WhiteSauce_round.b29def72.png";